import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PageTitle from 'components/PageTitle';
import Loader from 'components/Loader';
import Button from 'widgets/Button';
import CheckBox from 'components/CheckBox';
import colors from 'assets/styles/jsVariables/colors';
import { FormattedMessage } from 'react-intl';
import './CommunicationPreferences.scss';
import { ListItemText, ListItem, List } from '@material-ui/core';
import {
  getUserCommunicationPreferences,
  updateUserCommunicationPreferences
} from 'redux/actions/communicationPreferences';

const styles = {
  confirmButtonStyle: {
    '&:hover': {
      background: `${colors.darkerCyan} !important`,
      boxShadow: 'rgba(176, 176, 176, 0.5) 0px 2px 5px 1px'
    },
    boxShadow: 'none',
    height: '45px',
    width: '200px',
  },
  confirmButtonLabel: {
    fontFamily: 'museosansrounded_100',
    textTransform: 'capitalize',
    fontWeight: 600,
    fontSize: '16px'
  }
};

class CommunicationPreferences extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSelectAll: false,
      listItems: []
    }
  }

  componentDidMount() {
    this.updateCommunicationPreferences();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.communicationPreferences !== this.props.communicationPreferences) {
      this.updateCommunicationPreferences();
    }
  }

  updateCommunicationPreferences() {
    const { communicationPreferences } = this.props;

    if (communicationPreferences) {
      const listItems = Object.keys(communicationPreferences).map((key) => ({
        id: key,
        checked: communicationPreferences[key],
        title: <FormattedMessage id={`views.communicationPreferences.checklist.${key}.title`} />,
        description: <FormattedMessage id={`views.communicationPreferences.checklist.${key}.description`} />,
      }));

      this.setState({
        listItems,
        isSelectAll: listItems.every((item) => item.checked)
      });
    } else {
      this.props.getUserCommunicationPreferences();
    }
  }

  toggleAllCheckbox = () => {
    this.setState((prevState) => {
      const { isSelectAll, listItems } = prevState;
      const updatedListItems = listItems.map((item) => ({
        ...item,
        checked: !isSelectAll
      }));

      return {
        listItems: updatedListItems,
        isSelectAll: !isSelectAll
      };
    });
  };

  handleListItemClick = (index) => {
    const { listItems } = this.state;

    const updatedListItems = [...listItems];
    updatedListItems[index].checked = !updatedListItems[index].checked;

    this.setState({
      listItems: updatedListItems,
      isSelectAll: updatedListItems.every((item) => item.checked)
    });
  };

  buildUpdatedPreferences = () => {
    const { listItems } = this.state;
    const updatedPreferences = {};

    listItems.forEach((item) => {
      updatedPreferences[item.id] = item.checked;
    });

    return updatedPreferences;
  }

  handleSaveChanges = () => {
    this.props.updateUserCommunicationPreferences(this.buildUpdatedPreferences());
  }

  render() {
    const { isSelectAll, listItems } = this.state;

    if (this.props.isFetching) {
      return <Loader />;
    }

    return (
      <div className="Communication-Preferences">
        <PageTitle
          title={<FormattedMessage id="views.communicationPreferences.pageTitle" />}
          upperCase={false}
          labelStyle={{
            fontSize: '22px',
            color: colors.averageGrey,
            fontWeight: 500,
            letterSpacing: '0.25px',
          }}
          showDivider={true}
        />
        <div className="Communication-Preferences__Description">
          <div className="Communication-Preferences__Checkboxes-Container">
            <List className="Communication-Preferences__List">
              {listItems.map((item, index) => {
                const labelId = `checkbox-list-label-${index}`;

                return (
                  <ListItem key={index} role={undefined} onClick={() => this.handleListItemClick(index)} button className="Communication-Preferences__List-Item">
                    <CheckBox
                      name="chkBox"
                      id={item.id}
                      key={item.id}
                      checked={item.checked}
                      style={{
                        strokeWidth: '1.1px',
                        stroke: colors.background,
                        padding: 0
                      }}
                      label={<ListItemText id={labelId} primary={item.title} secondary={item.description} classes={{ primary: 'List-Item-Text__Primary', secondary: 'List-Item-Text__Secondary' }} />}
                      containerStyle={{ width: '100%' }}
                    />
                  </ListItem>
                );
              })}
            </List>
          </div>

        </div>
        <div className="Communication-Preferences__Action">
          <Button
            id="SaveChangesButton"
            variant="contained"
            color="primary"
            onClick={this.handleSaveChanges}
            cssStyles={{
              root: styles.confirmButtonStyle,
              label: styles.confirmButtonLabel
            }}
          >
            <FormattedMessage id="views.communicationPreferences.saveChanges.button" />
          </Button>
          <a href="#" onClick={this.toggleAllCheckbox} className="Communication-Preferences__Link">
            { isSelectAll ? <FormattedMessage id="views.communicationPreferences.unsubscribeFromAll" /> : <FormattedMessage id="views.communicationPreferences.subscribeToAll" /> }
          </a>
        </div>
      </div>
    );
  }
}

CommunicationPreferences.propTypes = {
  getUserCommunicationPreferences: PropTypes.func.isRequired,
  updateUserCommunicationPreferences: PropTypes.func.isRequired,
  communicationPreferences: PropTypes.object,
  isFetching: PropTypes.bool
};

const mapStateToProps = ({ communicationPreferences }) => ({
  communicationPreferences: communicationPreferences.info,
  isFetching: communicationPreferences.isFetching
});

const mapDispatchToProps = (dispatch) => {
  return {
    getUserCommunicationPreferences: () => {
      dispatch(getUserCommunicationPreferences());
    },
    updateUserCommunicationPreferences: (args) => {
      dispatch(updateUserCommunicationPreferences(args));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommunicationPreferences);



// WEBPACK FOOTER //
// ./src/views/CommunicationPreferences/CommunicationPreferences.jsx